import { styled } from "styled-components";
import Theme from "../../../styles/Theme/Theme";
import { Text } from "../../Global/Atomics/Text";
import CustomIcon from "../../Global/Icons/CustomIcon";
//#region  Styled Components
//Where we define the styles, CSS and other aspects for the page components
const Container = styled.div`
    background-color: ${Theme.color['white']};
    display: flex;
    justify-content: center;
    
    & div{
        display: flex;
        margin-right: 2px;
    }
`;
//#endregion
export const Fluctuation = () => {
    const tendency = 1;

    return (
        <Container>
            <div>
                <CustomIcon iconsize='sm'
                    icon={checkTendency(tendency)}
                    color={tendency === 1 ? 'error-4' : tendency === 2 ? 'success-4' : null}
                    bgColor={tendency === 1 ? 'error-1' : tendency === 2 ? 'success-1' : null} />
            </div>
            <Text $fontSize='text_sm' $fontColor='error-4' $weight='medium'>0%</Text>
            <Text $fontColor='coolgray-12' $marginLeft='s02' $fontSize='text_sm' $weight='medium' >menos do que no ano anterior</Text>
            {/* <Text $fontColor='coolgray-12' $marginLeft='s02' $fontSize='text_sm'$weight='medium' >less than last year</Text> EN VERSION  */}
        </Container>
    )
}

function checkTendency(value) {
    if (value === 1) {
        return 'ArrowDown'
    } else {
        return 'ArrowUp'
    }
}